export class SendingToFinance {
    id: number;
    user: any;
    company: any;
    companyCostCenter: any;
    dated: Date;
    closed: any;
    origin: string;
}
